import moment from 'moment';
import { ListTable } from '@/Components/ListTable';
import styles from './ScanWiseTable.module.scss';

const TABLE_COLUMNS = [
	{
		title: 'QR ID of Box',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Pack Size',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'No. of Pcs in Box',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Movement Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Is Stock Updated',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity By',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'QR ID of Box': 'qrId',
	'Pack Size': 'packSize',
	'No. of Pcs in Box': 'pcsInBox',
	'Movement Type': 'movementType',
	'Activity Date': 'activityDate',
	'Is Stock Updated': 'stockUpdated',
	'Activity By': 'activityBy',
};

const PackScanWiseTable = (props) => {
	const { data } = props;

	const SPECIAL_ITEMS = {
		'QR ID of Box': (qrId) => {
			return (
				<a
					className='underline text-blue-400'
					href={`/console2/order/tracking?type=qrCode&value=${qrId}`}
					target='_blank'
					rel='noreferrer'
				>
					{qrId}
				</a>
			);
		},
		'Activity Date': (activityDate) => {
			return (
				<div className='w-[150px]'>
					{moment(activityDate)?.format('YYYY-MM-DD HH:mm A')}
				</div>
			);
		},
		'Is Stock Updated': (stockUpdated) => {
			return stockUpdated === false ? 'No' : 'Yes';
		},
		'Movement Type': (movementType) => {
			const colorClass = movementType === 'Stocked In'
				? 'bg-green-100 text-green-800'
				: 'bg-red-100 text-red-800';
			return (
				<span className={`px-2 py-1 rounded text-xs font-medium ${colorClass}`}>
					{movementType}
				</span>
			);
		},
	};

	const getRowStyles = (ele) => {
		if (ele?.movementType === 'Stocked In') {
			return 'bg-[#00ff0d41]';
		}
		if (ele?.movementType === 'Stocked Out') {
			return 'bg-[#ff0c0c41]';
		}
		return '';
	};

	return (
		<div className={`${styles.root} ${styles.small}`}>
			<ListTable
				allowCheckList={false}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={data?.map((ele) => {
					return {
						...ele,
						rowStyles: getRowStyles(ele),
					};
				})}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};

export default PackScanWiseTable;
